import React from 'react'
import { IconMenuTeac } from '../../IU/IconMenuTeac/IconMenuTeac'

export const NavBar = () => {
  return (
    <div>
        <IconMenuTeac />
    </div>
  )
}
